module.exports = __webpack_public_path__ + "static/img/025.6d77308.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/fushen/025.png
// module id = l8X/
// module chunks = 0